module.exports = __webpack_public_path__ + "static/img/img1.d5399d1b.png";